import { AutogenLayoutPortalDefinitions } from "./autogen/AutogenLayoutPortalDefinitions";
import {  DataSourceExecutionEvent, DropdownItem,  ClickEvent,  DataSourceMode,  TableSelectionEvent, Layout, Textbox, Panel,  TableRowModeChangeEvent,  DropdownSelectionEvent,  TableRowDisplayEvent } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { PortalSqlDDef } from "./PortalSqlDDef";
import { PortalSqlHDef } from "./PortalSqlHDef";
import { ModelRow } from "@mcleod/core";
import { PortalFieldsDefs } from "./PortalFieldsDefs";
import { ImgLic } from "./ImgLic";

export class PortalDefinitions extends AutogenLayoutPortalDefinitions {
    private timer: any;

    override async onLoad() {
        const st: boolean = await ImgLic.renlgxLicensed();
        if( st == false )
        {   //just in case someone tries to access directly
            //await CommonDialogs.showMessage("Sorry You do not have access...", "Document Power");
            close();
        }
        else
        {
            clearInterval(this.timer);
            this.timer = setInterval(() => this.loadsqld(), 100);
        }
    }

    loadsqld() {
        clearInterval(this.timer);
        this.timer = null;
        this.tblsqlh.selectedIndex = 0; //triggers tblsqlhOnSelect
    }

/** This is an event handler for the afterExecution event of sourceRenditionLogixProfiles. */
  sourceRenditionLogixProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows)
    {
        items.push(new DropdownItem( row._data.lgxp_id, row._data.lgxp_id ));
    }
    this.textboxLgxpId.items = items;
    this.textboxLgxpId.selectedItem = items[0];
  }

///// SQL Header Handlers
/** This is an event handler for the onSelect event of tblsqlh. */
  async tblsqlhOnSelect(event: TableSelectionEvent) {
    if( this.tblsqlh.selectedRow != null )
    {
        const fldrow: any = this.tblsqlh.selectedRow.data;
        const id = fldrow._data.lgxsh_sqlgid;
        await this.sourceRenlgxsqld.search( { lgxsd_sqlgid: id });
    }
    this.sourceRenditionLogixProfiles.search();
  }

/** This is an event handler for the onClick event of pbAddsqlh. */
  async pbAddsqlhOnClick(event: ClickEvent) {
    await this.sourceRenlgxsqlh2.search();
    const rows: any[] = this.sourceRenlgxsqlh2.data;
    let maxid = 0;
    for (const row of rows) {
        const fid = row._data.lgxsh_sqlgid;
        if( fid > maxid )
            maxid = fid;
    }
    maxid++;
    const layout = await Layout.getLoadedLayout( this.tblsqlh.addLayout ) as PortalSqlHDef;
    layout.textboxLgxshSqlgid.text = maxid.toString();
    layout.textboxLgxshSqlgid.enabled = false;
    layout.textboxLgxshDesc.required = true;
    const dlg: any = CommonDialogs.createDialog( layout, { title: "Add SQL Definition", okVisible: true } );
    const result = await dlg.show();
    if( result == true )
    {
        const row: any = new ModelRow("imaging/renlgxsqlh", true);
        row.set( "lgxsh_sqlgid", maxid );
        row.set( "lgxsh_desc", layout.textboxLgxshDesc.text );

        row.mode = DataSourceMode.ADD;
        this.sourceRenlgxsqlh.setRowsAndMode( row.mode, [row], null );
        this.sourceRenlgxsqlh.mode = DataSourceMode.ADD;
        const rrow = await this.sourceRenlgxsqlh.post();
        if( rrow == null )
        {
            CommonDialogs.showMessage("Error adding SQL ID '" + maxid + "'.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        else
        {
            //reload headers
            this.sourceRenlgxsqlh.search();
        }
    }

  }

/** This is an event handler for the onClick event of pbEditsqlh. */
  async pbEditsqlhOnClick(event: ClickEvent) {
    if( this.tblsqlh.selectedRow != null )
    {
        const fldrow: any = this.tblsqlh.selectedRow.data;
        const id = fldrow._data.lgxsh_sqlgid;
        const desc = fldrow._data.lgxsh_desc;
        const recid = fldrow._data.lgxsh_recid;
        const layout = await Layout.getLoadedLayout( this.tblsqlh.editLayout ) as PortalSqlHDef;
        layout.textboxLgxshSqlgid.text = id.toString();
        layout.textboxLgxshSqlgid.enabled = false;
        layout.textboxLgxshDesc.text = desc;
        const dlg: any = CommonDialogs.createDialog( layout, { title: "Edit SQL Definition", okVisible: true } );
        const result = await dlg.show();
        if( result == true )
        {
            const row: any = new ModelRow("imaging/renlgxsqlh", true);
            row.set( "lgxsh_recid", recid );
            row.set( "lgxsh_sqlgid", id );
            row.set( "lgxsh_desc", layout.textboxLgxshDesc.text );

            row.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxsqlh.setRowsAndMode( row.mode, [row], null );
            const rrow = await this.sourceRenlgxsqlh.post();
            if( rrow == null )
            {
                CommonDialogs.showMessage("Error updating Field '" + id + "'.",
                    "Document Power", { resizable: true, movable: true });
                return;
            }
            else
            {
                //reload details
                this.sourceRenlgxsqlh.search();
            }
        }
    }
    else
    {
        CommonDialogs.showMessage("Please select a SQL Group to edit.",
            "Document Power", { resizable: true, movable: true });
    }

  }

/** This is an event handler for the onClick event of pbDelsqlh. */
  async pbDelsqlhOnClick(event: ClickEvent) {
    if( this.tblsqlh.selectedRow != null )
    {
        const fldrow: any = this.tblsqlh.selectedRow.data;
        const id = fldrow._data.lgxsh_sqlgid;
        await this.sourceRenlgxsqld2.search( { lgxsd_sqlgid: id });
        if( this.sourceRenlgxsqld2.data.length > 0 )
        {
            CommonDialogs.showMessage("Error Cannot delete sql group that is in use by sql detail.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        const rows: any[] = this.sourceRenlgxsqlh.data;
        for( let i = rows.length - 1; i >= 0; i-- )
        {
            const row: any = rows[i];
            if( row._data.lgxsh_sqlgid == id )
            {
                row.mode = DataSourceMode.NONE;
                this.sourceRenlgxsqlh.setRowsAndMode( row.mode, [row], null );
                this.sourceRenlgxsqlh.delete( );
                clearInterval(this.timer);
                this.timer = setInterval(() => this.reloadRenLgxsqlh(), 100);
                break;
            }
        }
    }
    else
    {
        CommonDialogs.showMessage("Please select a SQL Group to delete.",
            "Document Power", { resizable: true, movable: true });
    }
  }

  reloadRenLgxsqlh() {
    clearInterval(this.timer);
    this.timer = null;
    this.sourceRenlgxsqlh.search();
  }

/** This is an event handler for the onClick event of pbSearchsqlh. */
  async pbSearchsqlhOnClick(event: ClickEvent) {
    const layout = await Layout.getLoadedLayout( this.tblsqlh.editLayout ) as PortalSqlHDef;
    layout.textboxLgxshSqlgid.enabled = true;
    const dlg: any = CommonDialogs.createDialog( layout, { title: "Search SQL Definition", okVisible: true } );
    const result = await dlg.show();
    if( result == true )
    {
        const id = layout.textboxLgxshSqlgid.text != "" ? parseInt( layout.textboxLgxshSqlgid.text ) : null;
        const desc = layout.textboxLgxshDesc.text;
        //reload details
        this.sourceRenlgxsqlh.search( { lgxsh_sqlgid: id, lgxsh_desc: desc } );
    }
  }

///// SQL Detail Handlers
/** This is an event handler for the onClick event of pbAddsqld. */
  async pbAddsqldOnClick(event: ClickEvent) {
    if( this.tblsqlh.selectedRow != null )
    {
        const sqlhrow: any = this.tblsqlh.selectedRow.data;
        const sqlgid = sqlhrow._data.lgxsh_sqlgid;
        await this.sourceRenlgxsqld2.search( { lgxsd_sqlgid: sqlgid } );
        const rows: any[] = this.sourceRenlgxsqld2.data;
        let maxid = 0;
        for (const row of rows) {
            const fid = row._data.lgxsd_sqlseq;
            if( fid > maxid )
                maxid = fid;
        }
        maxid++;
        const layout = await Layout.getLoadedLayout( this.tblsqld.addLayout ) as PortalSqlDDef;
        layout.textboxLgxsdSqlgid.text = sqlgid.toString();
        layout.textboxLgxsdSqlseq.text = maxid.toString();
        layout.textboxLgxsdSqlgid.enabled = false;
        layout.textboxLgxsdSqlseq.enabled = false;
        layout.textboxLgxsdSqlstmt.required = true;
        layout.textboxLgxsdStmtdesc.required = true;
        layout.textboxLgxsdMultirows.required = true;
        const dlg: any = CommonDialogs.createDialog( layout, { title: "Add SQL Definiton", okVisible: true } );
        const result = await dlg.show();
        if( result == true )
        {
            const row: any = new ModelRow("imaging/renlgxsqld", true);
            row.set( "lgxsd_sqlgid", sqlgid );
            row.set( "lgxsd_sqlseq", maxid );
            let stmt: string = layout.textboxLgxsdSqlstmt.text;
            stmt = this.cleanStmtTicks( stmt );
            row.set( "lgxsd_sqlstmt", stmt );
            row.set( "lgxsd_stmtdesc", layout.textboxLgxsdStmtdesc.text );
            row.set( "lgxsd_multirows", layout.textboxLgxsdMultirows.text[0] );

            row.mode = DataSourceMode.ADD;
            this.sourceRenlgxsqld.setRowsAndMode( row.mode, [row], null );
            this.sourceRenlgxsqld.mode = DataSourceMode.ADD;
            const rrow = await this.sourceRenlgxsqld.post();
            if( rrow == null )
            {
                CommonDialogs.showMessage("Error adding SQL Detail '" + sqlgid + "'.",
                    "Document Power", { resizable: true, movable: true });
                return;
            }
            else
            {
                //reload details
                this.sourceRenlgxsqld.search( { lgxsd_sqlgid: sqlgid });
            }
        }
    }
    else
    {
        CommonDialogs.showMessage("Please select a SQL Group before adding SQL details.",
            "Document Power", { resizable: true, movable: true });
    }
  }

/** This is an event handler for the onClick event of pbEditsqld. */
  async pbEditsqldOnClick(event: ClickEvent) {
    if( this.tblsqld.selectedRow != null )
    {
        const fldrow: any = this.tblsqld.selectedRow.data;
        const id = fldrow._data.lgxsd_sqlgid;
        const seq = fldrow._data.lgxsd_sqlseq;
        const desc = fldrow._data.lgxsd_stmtdesc;
        const stmt = fldrow._data.lgxsd_sqlstmt;
        const multi = fldrow._data.lgxsd_multirows;
        const recid = fldrow._data.lgxsd_recid;
        const layout = await Layout.getLoadedLayout( this.tblsqld.editLayout ) as PortalSqlDDef;
        layout.textboxLgxsdSqlgid.text = id.toString();
        layout.textboxLgxsdSqlseq.text = seq.toString();
        layout.textboxLgxsdStmtdesc.text = desc;
        layout.textboxLgxsdSqlstmt.text = stmt;
        layout.textboxLgxsdMultirows.text = multi;
        layout.textboxLgxsdSqlgid.enabled = false;
        layout.textboxLgxsdSqlseq.enabled = false;
        const dlg: any = CommonDialogs.createDialog( layout, { title: "Edit SQL Definition", okVisible: true } );
        const result = await dlg.show();
        if( result == true )
        {
            const row: any = new ModelRow("imaging/renlgxsqld", true);
            row.set( "lgxsd_recid", recid );
            row.set( "lgxsd_sqlgid", id );
            row.set( "lgxsd_stmtdesc", layout.textboxLgxsdStmtdesc.text );
            let stmt: string = layout.textboxLgxsdSqlstmt.text;
            stmt = this.cleanStmtTicks( stmt );
            row.set( "lgxsd_sqlstmt", stmt );
            row.set( "lgxsd_multirows", layout.textboxLgxsdMultirows.text[0] );

            row.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxsqld.setRowsAndMode( row.mode, [row], null );
            const rrow = await this.sourceRenlgxsqld.post();
            if( rrow == null )
            {
                CommonDialogs.showMessage("Error updating Field '" + id + "'.",
                    "Document Power", { resizable: true, movable: true });
                return;
            }
            else
            {
                //reload details
                this.sourceRenlgxsqld.search( { lgxsd_sqlgid: id } );
            }
        }
    }
    else
    {
        CommonDialogs.showMessage("Please select a SQL Detail to edit.",
            "Document Power", { resizable: true, movable: true });
    }
  }

  cleanStmtTicks( stmt: string ): string {
    const s: any = stmt;
    let r: any = "";
   	for( let i=0; i < s.length; i++ )
	{   //keep ascii characters only
		if( s[i] >= ' ' && s[i] <= '}' )
			r += s[i];
	}
    stmt = r;
    stmt = stmt.replace( /\r\n/g, " " );    //remove new lines
    stmt = stmt.replace( /'/g, "[" );       //replace ticks with [
    let rstmt = "";
    const l = stmt.length;
    for( let i=0; i < stmt.length; i++ )
        rstmt += stmt.charAt(l-i-1);
    return rstmt;
  }

/** This is an event handler for the onClick event of pbDelsqld. */
  async pbDelsqldOnClick(event: ClickEvent) {
    if( this.tblsqld.selectedRow != null )
    {
        const fldrow: any = this.tblsqld.selectedRow.data;
        const id = fldrow._data.lgxsd_sqlgid;
        const seq = fldrow._data.lgxsd_sqlseq;
        await this.sourceRenlgxpflds2.search( { lgxpf_sqlgid: id, lgxpf_sqlseq: seq });
        if( this.sourceRenlgxpflds2.data.length > 0 )
        {
            CommonDialogs.showMessage("Error Cannot delete sql statement that is in use by portal fields.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        const rows: any[] = this.sourceRenlgxsqld.data;
        for( let i = rows.length - 1; i >= 0; i-- )
        {
            const row: any = rows[i];
            if( row._data.lgxsd_sqlgid == id && row._data.lgxsd_sqlseq == seq )
            {
                row.mode = DataSourceMode.NONE;
                this.sourceRenlgxsqld.setRowsAndMode( row.mode, [row], null );
                this.sourceRenlgxsqld.delete( );
                clearInterval(this.timer);
                this.timer = setInterval(() => this.reloadRenLgxsqld(id), 100);
                break;
            }
        }
    }
    else
    {
        CommonDialogs.showMessage("Please select a SQL Detail to delete.",
            "Document Power", { resizable: true, movable: true });
    }
  }

  reloadRenLgxsqld(id: any) {
    clearInterval(this.timer);
    this.timer = null;
    this.sourceRenlgxsqld.search( { lgxsd_sqlgid: id } );
  }

/** This is an event handler for the onClick event of pbSearchsqlh. */
  async pbSearchsqldOnClick(event: ClickEvent) {
    const layout = await Layout.getLoadedLayout( this.tblsqld.editLayout ) as PortalSqlDDef;
    layout.textboxLgxsdSqlgid.enabled = true;
    layout.textboxLgxsdSqlseq.enabled = true;
    layout.textboxLgxsdStmtdesc.required = false;
    layout.textboxLgxsdSqlstmt.required = false;
    layout.textboxLgxsdMultirows.required = false;
    const dlg: any = CommonDialogs.createDialog( layout, { title: "Search SQL Definition", okVisible: true } );
    const result = await dlg.show();
    if( result == true )
    {
        const id = layout.textboxLgxsdSqlgid.text != "" ? parseInt( layout.textboxLgxsdSqlgid.text ) : null;
        const seq = layout.textboxLgxsdSqlseq.text != "" ? parseInt( layout.textboxLgxsdSqlseq.text ) : null;
        const desc = layout.textboxLgxsdStmtdesc.text;
        const stmt = layout.textboxLgxsdSqlstmt.text;
        const multi = layout.textboxLgxsdMultirows.text[0];
        //reload details
        this.sourceRenlgxsqld.search( { lgxsd_sqlgid: id, lgxsd_sqlseq: seq, lgxsd_stmtdesc: desc, lgxsd_multirows: multi,
            lgxsd_sqlstmt: stmt } );
    }
  }


/** This is an event handler for the onSelect event of tblsqld. */
  tblsqldOnSelect(event: TableSelectionEvent) {
    if( this.tblsqld.selectedRow != null )
    {
        const t: any = this.tblsqld.selectedRow.findComponentById("textboxLgxsdSqlstmt") as Textbox;
        t.printable = t.printable ? false : true;
        t.enabled = false;
    }
  }

///// Field Definition Handlers
/** This is an event handler for the onClick event of pbAddFieldDef. */
  async pbAddFieldDefOnClick(event: ClickEvent) {
    const rows: any[] = this.sourceRenlgxflds.data;
    let maxid = 0;
    for (const row of rows) {
        const fid = row._data.lgxf_id;
        if( fid > maxid )
            maxid = fid;
    }
    maxid++;
    const layout = await Layout.getLoadedLayout( this.tblflds.addLayout ) as PortalFieldsDefs;
    layout.textboxLgxfId.text = maxid.toString();
    layout.textboxLgxfId.enabled = false;
    const dlg: any = CommonDialogs.createDialog( layout, { title: "Add Field Definition", okVisible: true } );
    const result = await dlg.show();
    if( result == true )
    {
        const row: any = new ModelRow("imaging/renlgxflds", true);
        row.set( "lgxf_id", maxid );
        row.set( "lgxf_tblname", layout.textboxLgxfTblname.text );
        row.set( "lgxf_fldname", layout.textboxLgxfFldname.text );
        row.set( "lgxf_label", layout.textboxLgxfLabel.text );

        row.mode = DataSourceMode.ADD;
        this.sourceRenlgxflds.setRowsAndMode( row.mode, [row], null );
        this.sourceRenlgxflds.mode = DataSourceMode.ADD;
        const rrow = await this.sourceRenlgxflds.post();
        if( rrow == null )
        {
            CommonDialogs.showMessage("Error adding Field '" + maxid + "'.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        else
        {
            //reload details
            this.sourceRenlgxflds.search();
        }
    }

  }

/** This is an event handler for the onClick event of pbEditFieldDef. */
  async pbEditFieldDefOnClick(event: ClickEvent) {
    if( this.tblflds.selectedRow != null )
    {
        const fldrow: any = this.tblflds.selectedRow.data;
        const id = fldrow._data.lgxf_id;
        const tn = fldrow._data.lgxf_tblname;
        const fn = fldrow._data.lgxf_fldname;
        const ll = fldrow._data.lgxf_label;
        const recid = fldrow._data.lgxf_recid;
        const layout = await Layout.getLoadedLayout( this.tblflds.editLayout ) as PortalFieldsDefs;
        layout.textboxLgxfId.text = id.toString();
        layout.textboxLgxfId.enabled = false;
        layout.textboxLgxfTblname.text = tn;
        layout.textboxLgxfFldname.text = fn;
        layout.textboxLgxfLabel.text = ll;
        const dlg: any = CommonDialogs.createDialog( layout, { title: "Edit Field Definition", okVisible: true } );
        const result = await dlg.show();
        if( result == true )
        {
            const row: any = new ModelRow("imaging/renlgxflds", true);
            row.set( "lgxf_recid", recid );
            row.set( "lgxf_id", id );
            row.set( "lgxf_tblname", layout.textboxLgxfTblname.text );
            row.set( "lgxf_fldname", layout.textboxLgxfFldname.text );
            row.set( "lgxf_label", layout.textboxLgxfLabel.text );

            row.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxflds.setRowsAndMode( row.mode, [row], null );
            //this.sourceRenlgxflds.mode = DataSourceMode.UPDATE;
            const rrow = await this.sourceRenlgxflds.post();
            if( rrow == null )
            {
                CommonDialogs.showMessage("Error updating Field '" + id + "'.",
                    "Document Power", { resizable: true, movable: true });
                return;
            }
            else
            {
                //reload details
                this.sourceRenlgxflds.search();
            }
        }
    }
  }

/** This is an event handler for the onClick event of pbDelFieldDef. */
  async pbDelFieldDefOnClick(event: ClickEvent) {
    if( this.tblflds.selectedRow != null )
    {
        const fldrow: any = this.tblflds.selectedRow.data;
        const id = fldrow._data.lgxf_id;
        await this.sourceRenlgxpflds.search( { lgxpf_fieldid: id });
        if( this.sourceRenlgxpflds.data.length > 0 )
        {
            CommonDialogs.showMessage("Error Cannot delete field definition that is in use by a profile.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        const rows: any[] = this.sourceRenlgxflds.data;
        for( let i = rows.length - 1; i >= 0; i-- )
        {
            const row: any = rows[i];
            if( row._data.lgxf_id == id )
            {
                row.mode = DataSourceMode.NONE;
                this.sourceRenlgxflds.setRowsAndMode( row.mode, [row], null );
                this.sourceRenlgxflds.delete( );
                clearInterval(this.timer);
                this.timer = setInterval(() => this.reloadRenLgxflds(), 100);
                break;
            }
        }
    }
  }

  reloadRenLgxflds() {
    clearInterval(this.timer);
    this.timer = null;
    this.sourceRenlgxflds.search();
  }

/** This is an event handler for the onClick event of pbSearchFieldDef. */
  async pbSearchFieldDefOnClick(event: ClickEvent) {
    const layout = await Layout.getLoadedLayout( this.tblflds.editLayout ) as PortalFieldsDefs;
    layout.textboxLgxfId.enabled = true;
    layout.textboxLgxfId.required = false;
    layout.textboxLgxfTblname.required = false;
    layout.textboxLgxfFldname.required = false;
    layout.textboxLgxfLabel.required = false;
    const dlg: any = CommonDialogs.createDialog( layout, { title: "Search Fields Definition", okVisible: true } );
    const result = await dlg.show();
    if( result == true )
    {
        const id = layout.textboxLgxfId.text != "" ? parseInt( layout.textboxLgxfId.text ) : null;
        const tn = layout.textboxLgxfTblname.text;
        const fn = layout.textboxLgxfFldname.text;
        const ll = layout.textboxLgxfLabel.text;
        //reload details
        this.sourceRenlgxflds.search( { lgxf_id: id, lgxf_tblname: tn, lgxf_fldname: fn, lgxf_label: ll } );
    }
  }

///// Portal Field Handlers
/** This is an event handler for the onClick event of pbAddPortalField. */
  async pbAddPortalFieldOnClick(event: ClickEvent) {
    if( this.tblflds.selectedRow != null && this.tblsqld.selectedRow != null && this.textboxLgxpId.text != "" )
    {
        this.DisableButtons();
        const fldrow: any = this.tblflds.selectedRow.data;
        const sqlrow: any = this.tblsqld.selectedRow.data;
        if( this.tblpflds.rowCount > 0 )
        {
            const pfldrow: any = this.tblpflds.rows[0].data;
            const pfldgid = pfldrow._data.lgxpf_sqlgid;
            if( pfldgid != sqlrow._data.lgxsd_sqlgid )
            {
                CommonDialogs.showMessage("Error adding Portal Field, incorrect sql group.'",
                    "Document Power", { resizable: true, movable: true });
                this.timer = setInterval(() => this.EnableButtons(), 2000);
                return;
            }
        }

        const row: any = new ModelRow("imaging/renlgxpflds", true);
        row.set( "lgxpf_fldseq", this.tblpflds.rowCount + 1 );
        row.set( "lgxpf_profileid", this.textboxLgxpId.text );
        row.set( "lgxpf_fieldid", fldrow._data.lgxf_id );
        row.set( "lgxpf_sqlgid", sqlrow._data.lgxsd_sqlgid );
        row.set( "lgxpf_sqlseq", sqlrow._data.lgxsd_sqlseq );
        row.set( "lgxpf_copy2cb", this.cbCopyToCB.checked ? "Y" : "N" );
        row.mode = DataSourceMode.ADD;
        this.sourceRenlgxpflds.setRowsAndMode( row.mode, [row], null );
        this.sourceRenlgxpflds.mode = DataSourceMode.ADD;
        const rrow = await this.sourceRenlgxpflds.post();
        if( rrow == null )
        {
            CommonDialogs.showMessage("Error adding Portal Field.'",
                "Document Power", { resizable: true, movable: true });
        }
        else
        {
            //reload details
            this.sourceRenlgxpflds.search( { lgxpf_profileid: this.textboxLgxpId.text } );
        }
        this.timer = setInterval(() => this.EnableButtons(), 2000);
    }
    else
    {
        CommonDialogs.showMessage("Please select a field, sql statement and profile before adding to portal.",
            "Document Power", { resizable: true, movable: true });
    }
  }

/** This is an event handler for the onClick event of pbDelPortalField. */
  async pbDelPortalFieldOnClick(event: ClickEvent) {
    if( this.tblpflds.selectedRow != null )
    {
        this.DisableButtons();
        const rowDel: any = this.tblpflds.selectedRow.data;
        const id: any = rowDel._data.lgxpf_fieldid;
        const seq: any = rowDel._data.lgxpf_fldseq;
        const recid: any = rowDel._data.lgxpf_recid;
        const profileid = rowDel._data.lgxpf_profileid;

        rowDel.mode = DataSourceMode.NONE;
        this.sourceRenlgxpflds.setRowsAndMode( rowDel.mode, [rowDel], null );
        this.sourceRenlgxpflds.delete();
        //update sequences after deleted row
        let nstr = ">" + seq;
        await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid, "lgxpf_fldseq": nstr } );
        for( let i=0; i < this.sourceRenlgxpflds.rowCount; i )
        {
            this.sourceRenlgxpflds.rowIndex = i;
            const rowUpd: any = this.sourceRenlgxpflds.activeRow;
            let pseq: any = rowUpd._data.lgxpf_fldseq;
            pseq -= 1;
            rowUpd.set( "lgxpf_fldseq", pseq );
            rowUpd.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxpflds.setRowsAndMode( rowUpd.mode, [rowUpd], null );
            await this.sourceRenlgxpflds.post();
            nstr = ">" + pseq;
            await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid, "lgxpf_fldseq": nstr } );
        }
        await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid } );   //reload profile
        this.timer = setInterval(() => this.EnableButtons(), 2000);
    }
  }

/** This is an event handler for the onClick event of pbUpPortalField. */
  async pbUpPortalFieldOnClick(event: ClickEvent) {
    if( this.tblpflds.selectedRow != null && this.tblpflds.selectedRow.data._data.lgxpf_fldseq > 1 )
    {
        this.DisableButtons();
        const idx: any = this.tblpflds.selectedIndex;
        const rowDel: any = this.tblpflds.selectedRow.data;
        const id: any = rowDel._data.lgxpf_fieldid;
        const seq: any = rowDel._data.lgxpf_fldseq;
        const profileid: any = rowDel._data.lgxpf_profileid;
        const sqlgid: any = rowDel._data.lgxpf_sqlgid;
        const sqlseq: any = rowDel._data.lgxpf_sqlseq;
        const cptocb: any = rowDel._data.lgxpf_copy2cb;

        //Update selected row to temp seq
        rowDel.set( "lgxpf_fldseq", 9999 );
        rowDel.mode = DataSourceMode.UPDATE;
        this.sourceRenlgxpflds.setRowsAndMode( rowDel.mode, [rowDel], null );
        await this.sourceRenlgxpflds.post();
        //update prev sequence
        const pseq = seq - 1;
        await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid, "lgxpf_fldseq": pseq } );
        for( let i=0; i < this.sourceRenlgxpflds.rowCount; i++ )
        {
            this.sourceRenlgxpflds.rowIndex = i;
            const rowUpd: any = this.sourceRenlgxpflds.activeRow;
            let pseq: any = rowUpd._data.lgxpf_fldseq;
            pseq += 1;
            rowUpd.set( "lgxpf_fldseq", pseq );
            rowUpd.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxpflds.setRowsAndMode( rowUpd.mode, [rowUpd], null );
            await this.sourceRenlgxpflds.post();
            //reupdate temp row
            rowDel.set( "lgxpf_fldseq", seq - 1 );
            rowDel.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxpflds.setRowsAndMode( rowDel.mode, [rowDel], null );
            await this.sourceRenlgxpflds.post();
            break;
        }
        await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid } );   //reload profile
        if( idx > 0 )
            this.tblpflds.selectedIndex = idx-1;
        this.timer = setInterval(() => this.EnableButtons(), 2000);
    }
  }

/** This is an event handler for the onClick event of pbDownPortalField. */
  async pbDownPortalFieldOnClick(event: ClickEvent) {
    if( this.tblpflds.selectedRow != null && this.tblpflds.selectedRow.data._data.lgxpf_fldseq < this.tblpflds.rowCount )
    {
        this.DisableButtons();
        const idx: any = this.tblpflds.selectedIndex;
        const rowDel: any = this.tblpflds.selectedRow.data;
        const id: any = rowDel._data.lgxpf_fieldid;
        const seq: any = rowDel._data.lgxpf_fldseq;
        const profileid: any = rowDel._data.lgxpf_profileid;
        const sqlgid: any = rowDel._data.lgxpf_sqlgid;
        const sqlseq: any = rowDel._data.lgxpf_sqlseq;
        const cptocb: any = rowDel._data.lgxpf_copy2cb;
        //Update selected row to temp seq
        rowDel.set( "lgxpf_fldseq", 9999 );
        rowDel.mode = DataSourceMode.UPDATE;
        this.sourceRenlgxpflds.setRowsAndMode( rowDel.mode, [rowDel], null );
        await this.sourceRenlgxpflds.post();
        //update next sequence
        const pseq = seq + 1;
        await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid, "lgxpf_fldseq": pseq } );
        for( let i=0; i < this.sourceRenlgxpflds.rowCount; i++ )
        {
            this.sourceRenlgxpflds.rowIndex = i;
            const rowUpd: any = this.sourceRenlgxpflds.activeRow;
            let pseq: any = rowUpd._data.lgxpf_fldseq;
            pseq -= 1;
            rowUpd.set( "lgxpf_fldseq", pseq );
            rowUpd.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxpflds.setRowsAndMode( rowUpd.mode, [rowUpd], null );
            await this.sourceRenlgxpflds.post();
            //reupdate temp row
            rowDel.set( "lgxpf_fldseq", seq + 1 );
            rowDel.mode = DataSourceMode.UPDATE;
            this.sourceRenlgxpflds.setRowsAndMode( rowDel.mode, [rowDel], null );
            await this.sourceRenlgxpflds.post();
            break;
        }
        await this.sourceRenlgxpflds.search( { "lgxpf_profileid": profileid } );   //reload profile
        if( idx < this.tblpflds.rowCount-1 )
            this.tblpflds.selectedIndex = idx+1;
        this.timer = setInterval(() => this.EnableButtons(), 2000);
    }
  }

  private DisableButtons()
  {
      this.pbAddPortalField.enabled = false;
      this.pbDelPortalField.enabled = false;
      this.pbUpPortalField.enabled = false;
      this.pbDownPortalField.enabled = false;
  }

  private EnableButtons()
  {
      clearInterval(this.timer);
      this.pbAddPortalField.enabled = true;
      this.pbDelPortalField.enabled = true;
      this.pbUpPortalField.enabled = true;
      this.pbDownPortalField.enabled = true;
      this.timer = null;
  }

/** This is an event handler for the afterDropdownSelection event of textboxLgxpId. */
  textboxLgxpIdAfterDropdownSelection(event: DropdownSelectionEvent) {
    this.sourceRenlgxpflds.search( { lgxpf_profileid: this.textboxLgxpId.text } );
  }


/** This is an event handler for the onRowDisplay event of tblsqld. */
  tblsqldOnRowDisplay(event: TableRowDisplayEvent) {
    const stmtbox = event.getTableRow().findComponentById("textboxLgxsdSqlstmt") as Textbox;
    const row: any = event.getTableRow().data;
    let stmt: string = stmtbox.text;
    stmt = this.cleanStmt( stmt );
    row.set( "lgxsd_sqlstmt", stmt );
    stmtbox.text = stmt;
  }

  cleanStmt( stmt: string ): string {
    stmt = stmt.replace( /\r\n/g, " " );    //remove new lines
    stmt = stmt.replace( /\[/g, "'" );      //replace [ with ticks
    let rstmt = "";
    const l = stmt.length;
    for( let i=0; i < stmt.length; i++ )
        rstmt += stmt.charAt(l-i-1);
    return rstmt;
  }

/** This is an event handler for the onRowDisplay event of tblpflds. */
  tblpfldsOnRowDisplay(event: TableRowDisplayEvent) {
    const fidbox = event.getTableRow().findComponentById("textboxLgxpfFieldid") as Textbox;
    const gidbox = event.getTableRow().findComponentById("textboxLgxpfSqlgid") as Textbox;
    const seqbox = event.getTableRow().findComponentById("textboxLgxpfSqlseq") as Textbox;
    const row1: any = event.getTableRow().data;
    const fid: any = row1._data.lgxpf_fieldid;
    const gid: any = row1._data.lgxpf_sqlgid;
    const seq: any = row1._data.lgxpf_sqlseq;
    let rows: any[] = this.sourceRenlgxflds.data;
    for( const row of rows )
    {
        if( row._data.lgxf_id == fid )
        {
            const desc: string = row._data.lgxf_fldname.toString();
            const gdesc = fid + " - " + desc;
            if( fidbox )
                fidbox.setProps({ text: gdesc/*, color: "warning"*/ });
            break;
        }
    }
    rows = this.sourceRenlgxsqlh.data;
    for( const row of rows )
    {
        if( row._data.lgxsh_sqlgid == gid )
        {
            const desc: string = row._data.lgxsh_desc.toString();
            const gdesc = gid + " - " + desc;
            if( gidbox )
                gidbox.setProps({ text: gdesc/*, color: "warning"*/ });
            break;
        }
    }
    rows = this.sourceRenlgxsqld.data;
    for( const row of rows )
    {
        if( row._data.lgxsd_sqlseq == seq && row._data.lgxsd_sqlgid == gid )
        {
            const desc: string = row._data.lgxsd_stmtdesc.toString();
            const gdesc = seq + " - " + desc;
            if( seqbox )
                seqbox.setProps({ text: gdesc/*, color: "warning"*/ });
            break;
        }
    }
  }
}
